import {useEffect, useState} from "react";
import moment, {duration as momentDuration} from "moment";
import {getLocalTime} from "../../../Utils/DateUtils";

/**
 * Returns a function that constructs a duration object from current moment in time
 * until end time provided by the parameter.
 *
 * @param {String} end
 * @returns {import("moment").Duration} - duration
 */
const getDurationFromNow = end => momentDuration(end.diff(moment()));

/**
 * Starts a timer from current time and until end time, refreshing every second.
 * After it reaches zero it cancels the setInterval and sets duration to zero.
 *
 * @param {String} end
 * @returns {{duration: import("moment").Duration, hasFinished: boolean}} duration
 */
const useCountDown = end => {
    const [duration, setDuration] = useState(getDurationFromNow(getLocalTime(end)));
    const [hasFinished, setHasFinished] = useState(false);
    useEffect(
        () => {
            setDuration(getDurationFromNow(getLocalTime(end)));
        },
        [end],
    );
    useEffect(
        () => {
            if (hasFinished) return;
            const id = setInterval(() => {
                setDuration(t => {
                    const newTime = t.clone().subtract(1, "seconds");

                    if (newTime.seconds() < 0) {
                        setHasFinished(true);
                        return momentDuration(0);
                    }

                    return newTime;
                });
            }, 1000);

            return () => {
                clearInterval(id);
            };
        },
        [hasFinished],
    );

    return {duration, hasFinished};
};

export default useCountDown;
